module.exports = __webpack_public_path__ + "static/overall_background-4b3e4f2ba1bd08992793d1590752faa0.jpg";